<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18iUqEd/tc-custom/9780253042149.jpg?1733089697941" alt="This image is the cover for the book Ubuntu and the Reconstitution of Community, World Philosophies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ubuntu and the Reconstitution of Community, World Philosophies
      </h1>
      <p class="bookDescription body article font2">
        <p></p><p><i>Ubuntu</i> is premised on the ethical belief that an individual's humanity is fostered in a network of human relationships: I am because you are; we are because you are. The essays in this lively volume elevate the debate about ubuntu beyond the buzzword it has become, especially within South African religious and political contexts. The seasoned scholars and younger voices gathered here grapple with a range of challenges that ubuntu puts forward. They break down its history and analyze its intellectual surroundings in African philosophical traditions, European modernism, religious contexts, and human rights discourses. The discussion embraces questions about what it means to be human and to be a part of a community, giving attention to moments of loss and fragmentation in postcolonial modernity, to come to a more meaningful definition of belonging in a globalizing world. Taken together, these essays offer a rich understanding of ubuntu in all of its complexity and reflect on a value system rooted in the everyday practices of ordinary people in their daily encounters with churches, schools, and other social institutions.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Ogude
      </h2>
      
      <p class="authorDescription body article"><P><P>James Ogude<B></B>is Senior Research Fellow and Director at the Centre for the Advancement of Scholarship, University of Pretoria.<B></B>He is author of <I>Ngugi's Novels and African History: Narrating the Nation</I>.</P></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4d4dadda